<template>
    <div v-if="isLeserserviceOrHigher" class="customer-session-delete-all-btn">
        <v-btn small v-bind="$attrs" class="ma-1 mr-3" color="error" :loading="deleting" :disabled="loading || deleting || sessions.length < 1" @click="show" >
            <v-icon small v-bind="$attrs" left>mdi-close-circle</v-icon> alle beenden
        </v-btn>
        <v-dialog :value="showDeleteAllDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline" primary-title >Sessions beenden</v-card-title>
                <v-card-text>
                    <p class="body-1 mb-2">
                        Sollen wirklich alle Sitzungen beendet werden?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" outlined @click="abbort" :disabled="loading || deleting">
                        Abbrechen
                    </v-btn>
                    <v-btn color="error" outlined :loading="deleting" :disabled="loading || deleting" @click="terminateAllSessions">
                        Sessions beenden
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
} from 'vuex';

export default {
    name: 'SessionDeleteAllBtn',
    computed: {
        ...mapState('customerSessions', [
            'loading',
            'deleting',
            'showDeleteAllDialog',
        ]),
        ...mapGetters('customerSessions', [
            'sessions',
        ]),
        ...mapGetters(['isLeserserviceOrHigher']),
    },
    methods: {
        ...mapMutations('customerSessions', [
            'hideDeleteAllDialog',
            'openDeleteAllDialog',
        ]),
        ...mapMutations('snackbar', ['success', 'error', 'info']),
        ...mapActions('customerSessions', [
            'terminateAllSessions',
        ]),
        show() {
            this.openDeleteAllDialog();
        },
        abbort() {
            this.hideDeleteAllDialog();
            this.info('Das Beenden wurde abgebrochen.');
        },
        deleteSessionHandler() {
            this.terminateAllSessions()
                .then(() => {
                    this.success('Das Beenden war erfolgreich.');
                })
                .catch(() => {
                    this.error('Das Beenden ist fehlgeschlagen.');
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
